import {
  CalendarIcon,
  ClipboardDocumentListIcon,
  ClockIcon,
  UserMinusIcon,
} from '@heroicons/react/24/outline';

import { SummaryCounts } from '../api/types';

// The four top-level dashboard views. Calendar has no badge; the three queue
// tabs each show a live count badge from the summary endpoint. This phase
// only the Calendar body is built — the queue tabs render a placeholder.

export type DashboardTab =
  | 'calendar'
  | 'no_show'
  | 'missing_timesheet'
  | 'needs_approval';

type Props = {
  active: DashboardTab;
  onChange: (tab: DashboardTab) => void;
  counts?: SummaryCounts;
};

const TabBar = ({ active, onChange, counts }: Props) => {
  const tab = (
    key: DashboardTab,
    label: string,
    Icon: typeof CalendarIcon,
    badge?: number,
  ) => (
    <button
      type="button"
      className={`dashv2-tab${active === key ? ' is-active' : ''}`}
      onClick={() => onChange(key)}
      id={`dashv2-tab-${key}`}
    >
      <Icon />
      {label}
      {badge != null && <span className="dashv2-tab-badge">{badge}</span>}
    </button>
  );

  return (
    <div className="dashv2-tabs" role="tablist">
      {tab('calendar', 'Calendar', CalendarIcon)}
      {tab('no_show', 'No show', UserMinusIcon, counts?.no_show)}
      {tab(
        'missing_timesheet',
        'Missing timesheet',
        ClipboardDocumentListIcon,
        counts?.missing_timesheet,
      )}
      {tab(
        'needs_approval',
        'Needs approval',
        ClockIcon,
        counts?.needs_approval,
      )}
    </div>
  );
};

export default TabBar;
